import { userlogout } from "../../Redux/Slice/Auth/AuthSlice";
import { store } from "../../Redux/Store";
import { navigate } from "../Navigator";
import showToast from "../Toast/ToastNotification";

export const HandleApiError = async (error) => {
    if (error?.response) {
        const { status, data } = error.response;
        const message = data?.message || data?.body?.message || "Something went wrong!";
        if (message === "Your account is inactive. Please contact admin.") {
            store.dispatch(userlogout());
            navigate('/login')
            return
        } else {
            showToast("error", `${message}`);
        }
    } else {
        showToast("error", "An unexpected error occurred");
    }
};
